import React from 'react'
import '../../stylesheet/activities.css'
import { useNavigate } from "react-router-dom";
import { RiArrowRightUpLine, RiArrowLeftDownLine } from 'react-icons/ri'
import TablePlaceholder from '../../Utils/TablePlaceholder'
import Report from './PrescriptionReport';


const Activities = ({ notify }) => {
    const navigate = useNavigate()
    const activitiesData = []
    let tempdata =
        [
            {
                id: 1,
                title: "New prescription created -  Adetunji Tobi ",
                body: "Fri Jun 15, 2022  GMT 13:00",
                icon: <RiArrowRightUpLine />,
                type: "created"

            },
            {
                id: 2,
                title: "Prescription Dispensed -  Adetunji Tobi ",
                body: "Fri Jun 15, 2022  GMT 13:00",
                icon: <RiArrowLeftDownLine />,
                type: "dispersed"

            },
            {
                id: 3,
                title: "New prescription created -  Adetunji Tobi ",
                body: "Fri Jun 15, 2022  GMT 13:00",
                icon: <RiArrowRightUpLine />,
                type: "created"

            },
            {
                id: 4,
                title: "New prescription created -  Adetunji Tobi ",
                body: "Fri Jun 15, 2022  GMT 13:00",
                icon: <RiArrowRightUpLine />,
                type: "created"


            },
            {
                id: 5,
                title: "Prescription Dispensed -  Adetunji Tobi ",
                body: "Fri Jun 15, 2022  GMT 13:00",
                icon: <RiArrowLeftDownLine />,
                type: "dispersed"
            },

        ]

    return (
        <div className="activities">
            <div className="header_act">
                <h2>Recent Activities</h2>
                <button onClick={() => {
                    navigate('/prescription/all_prescription')
                }}>
                    <p>View All</p>
                </button>
            </div>
            <div className="relative">
                {
                    tempdata.length > 0
                        ?
                        <div className="px-8 py-3" >
                            <Report maxList={5} noTopnav={true} notify={notify} />
                        </div>
                        : <TablePlaceholder lost="You have no previous Prescription,Create a new patient through the Prescription manager dropdown.
           Go to Prescription manager Add new patient."/>
                }

            </div>

        </div>
    )
}

export default Activities
